import { hash } from '@ember/helper';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import EmberTooltip from 'ember-tooltips/components/ember-tooltip';
import { eq } from 'ember-truth-helpers';

import { getBem } from 'umg-ember-backend/utils/get-bem';

import styles from './styles.module.css';

const bem = getBem(styles);

interface AvatarSignature {
  Args: {
    isTooltipVisible?: boolean;
    style?: 'white' | 'active';
    tooltip?: string;
    tooltipSide?: 'top' | 'right' | 'bottom' | 'left';
    user: { id: string; displayHeadline: string; initials: string };
  };
  Element: HTMLDivElement;
}

export default class UiAvatarComponent extends Component<AvatarSignature> {
  // Services
  @service declare currentUser: TODO;

  // Getter and setter
  get isTooltipVisible() {
    return this.args.isTooltipVisible ?? true;
  }

  get style() {
    return this.args.style ?? 'white';
  }

  get tooltip() {
    return this.args.tooltip ?? this.args.user.displayHeadline;
  }

  // Template
  <template>
    <div
      class={{bem
        (hash
          style=this.style is-current-user=(eq this.currentUser.id @user.id)
        )
      }}
      ...attributes
    >
      {{@user.initials}}

      {{#if this.tooltip}}
        <EmberTooltip @text={{this.tooltip}} @side={{@tooltipSide}} />
      {{/if}}
    </div>
  </template>
}
